import { helpers } from 'vuelidate/lib/validators';
import { DateTime } from 'luxon';

export default function minDateTime(value, date) {
  const givenDate = DateTime.fromISO(value);
  const minDate = DateTime.fromISO(date);
  return !helpers.req(value) || givenDate >= minDate;
}
